import React from "react";
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import { useStylesAccordion } from '../../styles/StyleComponents';
import AccordionActions from '@material-ui/core/AccordionActions';
import { PropTypes } from 'prop-types';

// Parametros props
//id: Id del componente
//title: titulo del acordeón
//descripcion: descripción del acordeón 
//children: el div de contenido React
//childrenActions: botones de acción del acordeón

AccordionCS.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    descripcion: PropTypes.string,
    children: PropTypes.node,
    childrenActions: PropTypes.node
};

AccordionCS.defaultProps = {
    id: 'Custom',
    title: "Acordeón",
    descripcion: 'Descripción',
    children: <></>,
    childrenActions: <></>,
}

function AccordionCS(props) {
    const classesAccordion = useStylesAccordion();
    const [expanded, setExpanded] = React.useState(props.expanded);

    const handleChange = (panel) => (event, newExpanded) => {
        localStorage.setItem("MsgSession", false);
        setExpanded(!panel);
    };

    return (
        <Accordion id={props.id} expanded={expanded} TransitionProps={{ unmountOnExit: true }} onChange={handleChange(expanded)}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id={props.id}>
                <Typography component="span" className={classesAccordion.heading}>{props.title}</Typography>
                <Typography component="span" className={classesAccordion.secondaryHeading}>{props.descripcion}</Typography>
            </AccordionSummary>
            <AccordionDetails id={props.id}>
                {props.children}
            </AccordionDetails>
            <AccordionActions>
                {props.childrenActions}
            </AccordionActions>
        </Accordion>
    );
}

export default React.memo(AccordionCS);